export const FIELD_TYPES = {
  DATA: 'data',
  SUMMARY: 'summary',
  SCHEDULE: 'schedule',
  FINANCE: 'finance',
  MISSION: 'mission',
};